<template>
    <div class="form form__number">
        <label
            v-if="label"
            :for="name | toKebabCase"
            class="form__number_title"
        >
            <template v-if="labelHtml">
                <div v-html="label"></div>
            </template>
            <template v-else>
                {{label | toCapitalize}}
            </template>
            <span class="asterisk" v-if="required">*</span></label>
        <input
            :disabled="disabled"
            type="number"
            :min="min"
            :max="max"
            step="1"
            class="form__number_input"
            :name="name | toKebabCase"
            :id="name | toKebabCase"
            v-model="newValue"
            v-validate="vValidate"
            :data-vv-as="dataVvAs ? dataVvAs : label.toLowerCase()"
            @click="emitFocus"
            @blur="emitBlur"
        >
        <span
            class="form__error form__number_error"
            v-if="errors.first(toKebabCase(name))"
        >
          <template v-if="customErrorActive && errors.items[0].rule !== 'max_value' && errors.items[0].rule !== 'min_value'">
            {{ customErrorText }}
          </template>
          <template v-else>
            {{ errors.first(toKebabCase(name)) }}
          </template>
        </span>
        <template v-if="$slots.default">
            <div class="form__number_hint">
                <template v-if="hintButton">
                    <component-button
                        :name="`form-number-hint-button-${name}`"
                        :text="true"
                        :size="'tiny'"
                        @click="emitHint"
                    >
                        <slot></slot>
                    </component-button>
                </template>
                <template v-else>
                    <slot></slot>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import { toKebabCase } from '@/functions'
import { maxNumber } from '@/variables'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'form-number',
  components: { ComponentButton },
  data () {
    return {
      maxNumber
    }
  },
  props: {
    value: {
      type: [String, Number]
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: 'Label'
    },
    labelHtml: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    //
    dataVvAs: {
      type: String,
      default: ''
    },
    vValidate: {
      default: ''
    },
    customErrorActive: {
      type: Boolean,
      default: false
    },
    customErrorText: {
      type: String
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: maxNumber
    },
    hintButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', Number(newValue))
      }
    }
  },
  methods: {
    emitFocus () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-focus')
    },
    emitBlur () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.resume()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-blur')
    },
    emitHint: function () {
      this.$emit('emit-hint')
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formnumber";
</style>
